// extracted by mini-css-extract-plugin
export default {"head":"producttable_head__7zAf+"};